import { Container, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import Footer from "../components/layout/Footer";
import Layout from "../components/layout/Layout";
import LoginLayout from "../components/layout/LoginLayout";
import { useIsAuthenticated } from "@azure/msal-react";
import BlockIcon from "@mui/icons-material/Block";

export default function WarningPage(props: { title: string; body: string }) {
  const { t } = useTranslation();
  const isAuthenticated = useIsAuthenticated();

  return (
    <div>
      {isAuthenticated ? <Layout /> : <LoginLayout />}
      <Container>
        <Stack
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="80vh"
          padding={3}
          spacing={3}
          sx={{ maxWidth: 480, margin: "auto", textAlign: "center" }}
        >
          <Typography variant="h3" paragraph>
            {t(props.title)}
          </Typography>

          <BlockIcon color="error" sx={{ width: 100, height: 100 }} />

          <Typography sx={{ color: "text.secondary" }}>
            {t(props.body)}
          </Typography>
        </Stack>
      </Container>
      <div
        style={{
          position: "absolute",
          left: 0,
          bottom: 0,
          right: 0,
        }}
      >
        <Footer />
      </div>
    </div>
  );
}
